module.exports = "../images-dpg/pdf.svg";